<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import utils from '@/common/utils.js'

export default {
  name: 'App',
  created() {
    // 获取webview路径上的值
    // 全局数据
    const debug = !true, //是否调试模式，为true时会打印相关的请求参数，且请求地址和token等权限都是本地的
     powDataToken = ['1561691589619875840','1586908289545928704','1632781015795761152','1601495282749669376','1626188411490664448'] //第一项为代理商权限
    const globalData = {
      apiPath: debug?'http://192.168.2.245:8080':'',
      token:debug?powDataToken[4]:'',
      debug,
      isShowMoney:true,//商户端首页默认是否展示金额
      isHasOrder:false,//商户端我的日收益是否显示订单明细
      isFirstShowAgreementModel:true,//商户端是否为第一次弹出合同弹窗
      location:{},//经纬度
      sessionId:'',//埋点的id
    }
    window.globalData = globalData
    // console.log(window.globalData,'App页面的值')
    if(!window.globalData.debug){
        utils.getGlobalData(window.location.hash)  
     }
  },
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  font-size: 0.28rem;
}
html {
  font-size: calc(100vw / 7.5);
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
  /* height: calc(100vh - 46px - env(safe-area-inset-bottom) - env(safe-area-inset-top)); */
  height: calc(100vh - env(safe-area-inset-bottom) - env(safe-area-inset-top));
  overflow: auto;
  position: absolute;
  /* padding: 46px 0 0 0; */
  padding: 0;
}

.nav-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px;
}
.van-nav-bar__left .van-icon{
  color: #636363 !important;
}
.van-nav-bar__left .van-nav-bar__arrow{
  font-size: 20px !important;
}
.van-nav-bar__title{
  font-size: 15px;
  color: #666;
}
/* toast的默认样式 */
.van-toast.van-newToast {
  font-size: .28rem;
  font-weight: 500;
  color: #FFFFFF;
  line-height: .44rem;
  /* background: rgba(0, 0, 0, 0.9); */
  /* box-shadow: 0 .12rem .32rem 0 rgba(0, 0, 0, 0.1); */
  background: #4c4c4c;
  border-radius: .16rem;
}

.van-toast--text.van-newToast {
  padding: .24rem .52rem;
}

/* dialog的默认样式 */
.van-dialog.van-newDialog {
  width: 6.4rem;
  border-radius: .16rem;
}

.van-newDialog .van-dialog__header {
  padding-top: .62rem;
  font-size: .34rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.9);
}

.van-newDialog .van-dialog__message {
  padding: .24rem .48rem .64rem;
  line-height: .48rem;
  color: rgba(0, 0, 0, 0.65);
  font-size: .32rem;
}

.van-newDialog .van-dialog__message--has-title {
  color: rgba(0, 0, 0, 0.65);
  padding-top: .24rem;
}

.van-newDialog .van-dialog__cancel,
.van-newDialog .van-dialog__confirm {
  height: 1.14rem;
}

.van-newDialog .van-button__text {
  font-size: .34rem;
  font-weight: 600;
}

.van-newDialog .van-dialog__cancel .van-button__text {
  font-weight: 400;
}

</style>



// WEBPACK FOOTER //
// src/App.vue